import { Dropdown, Offcanvas, Collapse } from 'bootstrap'
import Swiper, { Navigation } from 'swiper';
import AOS from 'aos';

import GLightbox from 'glightbox';

import 'swiper/css';
import 'swiper/css/navigation';

import 'aos/dist/aos.css'
import Headroom from "headroom.js";

import jQuery from 'jquery';

const trHead = () => {
	var header = document.querySelector(".tr-nav");
	var headroom  = new Headroom(header);

	headroom.init();
}

const domReady = (onReady) => {
	window.requestAnimationFrame(function check() {
		document.body ? onReady() : window.requestAnimationFrame(check)
	})
}

const trGallery = () => {
	if(document.body.contains(document.querySelector('.glightbox'))) {
		const galleryObjects = new GLightbox()
	}
}

const trSwipers = () => {
	// eslint-disable-next-line no-unused-vars
	const swiper = new Swiper('.swiper', {
		loop: true,
		slidesPerView: 'auto',
		spaceBetween: 20,
		modules: [Navigation],
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}

const trCollapse = () => {
	var collapseElementList = [].slice.call(document.querySelectorAll('.collapse'))

	// eslint-disable-next-line no-unused-vars
	var collapseList = collapseElementList.map(function (collapseEl) {
		return new Collapse(collapseEl)
	})
}

const trOffCanvas = () => {
	var offcanvasElementList = [].slice.call(document.querySelectorAll('.offcanvas'))

	// eslint-disable-next-line no-unused-vars
	var offcanvasList = offcanvasElementList.map(function (offcanvasEl) {
		return new Offcanvas(offcanvasEl)
	})
}

const trDropdown = () => {
	var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))

	// eslint-disable-next-line no-unused-vars
	var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
		return new Dropdown(dropdownToggleEl)
	})
}

const trInit = () => {
	trOffCanvas()
	trDropdown()
	trCollapse()
	trSwipers()
	trHead()
	trGallery()
}

domReady(() => {
	window.addEventListener("touchstart", function(){}, {passive: true} )

	trInit()
})

window.addEventListener('load', () => {
	AOS.init()
});